import React from "react"
import { StarIcon as StarSolid } from "@heroicons/react/24/solid"
import { StarIcon as StarOutline } from "@heroicons/react/24/outline"
import { twMerge } from "tailwind-merge"

// Five-star readout with fractional fill: the outlined star, and the solid
// one clipped over it to the rating (primary_hov by default)
export default function Stars({ value = 0, size = 16, color = "currentColor", className = "" }) {
  return (
    <span className={twMerge("inline-flex items-center gap-[1px] text-primary_hov", className)} aria-label={`${value} / 5`}>
      {[1, 2, 3, 4, 5].map((i) => {
        const fill = Math.max(0, Math.min(1, value - (i - 1)))
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            <StarOutline style={{ width: size, height: size, color }} />
            <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
              <StarSolid style={{ width: size, height: size, color }} />
            </span>
          </span>
        )
      })}
    </span>
  )
}
